import React from "react";
import { LoadingScreen } from "@packsize/components";

import { useUser } from "../../../hooks";
import type { LicenseTier } from "../../../schemas";
import type { LicensedProductCategoryName } from "../../../types";
import { InsufficientLicense } from "../../insufficient-license";

interface LicensedRouteProps {
	readonly children: React.ReactNode;
	readonly productCategory: LicensedProductCategoryName;
	readonly tier: LicenseTier;
	readonly licenseFeatureFlag?: string | string[];
	readonly bypassForPacksizeUser?: boolean;
	readonly bypassForPacksizePartner?: boolean;
}

export const LicensedRoute: React.FC<LicensedRouteProps> = ({
	children,
	productCategory,
	tier,
	licenseFeatureFlag,
	bypassForPacksizeUser,
	bypassForPacksizePartner,
}) => {
	const { hasLicense, isPacksizeUser, isPacksizePartner } = useUser();

	if (bypassForPacksizeUser === true && isPacksizeUser === true) {
		return children;
	}

	if (bypassForPacksizePartner === true && isPacksizePartner === true) {
		return children;
	}

	const licenseCheck = hasLicense(productCategory, tier, licenseFeatureFlag);

	if (licenseCheck === undefined) {
		return <LoadingScreen />;
	}

	if (licenseCheck === false) {
		return <InsufficientLicense product={productCategory} tier={tier} />;
	}

	return children;
};
